<template>
    <div id="documents">
<!--        <novin-documents v-if="psp=='NOVIN'" :is_main_merchant="true" :form_data="form_data"-->
<!--                         :wizard="wizard"></novin-documents>-->
        <pasargad-documents v-if="psp=='PASARGAD'" :form_data="form_data" :wizard="wizard"></pasargad-documents>
        <kt-row>
            <kt-col lg="4" md="6" xs="12">
                <kt-form-action style=" direction: ltr; display: inline;">
                    <kt-button
                            class="m-2"
                            size="md"
                            @click="step_back"
                            variant="danger"
                            type="submit"
                            v-bind:wide="true"
                            id="step_back"
                    >
                        {{ $t('label.step_back') }}
                    </kt-button>
                </kt-form-action>
            </kt-col>
            <kt-col v-if="$can('manage','pos') && ((form_data.status == posStatuses.CORRECTION) || (!form_data.terminal_number && wizard.operation=='edit'))"
                    lg="4" md="6" xs="12">
                <kt-form-action style=" display: inline;margin-right: 125px">
                    <kt-button
                            class="m-2"
                            size="md"
                            @click="submit('edit_all_by_admin')"
                            variant="success"
                            type="submit"
                            v-bind:wide="true"
                            id="edit_all_by_admin"
                    >
                        {{ $t('btn.edit') }}
                    </kt-button>
                </kt-form-action>
            </kt-col>
            <kt-col lg="4" md="6" xs="12"
             v-if="$can('manage','pos') && wizard.document_operation == manageDocuments.UPLOAD  && psp=='PASARGAD'">
                <kt-form-action style=" display: inline;">
                    <kt-button
                            class="m-2"
                            size="md"
                            @click="uploadDocs"
                            variant="success"
                            type="submit"
                            v-bind:wide="true"
                            id="upload_documents"
                    >
                        {{ $t('pos.upload_documents') }}
                    </kt-button>
                </kt-form-action>
            </kt-col>
            <kt-col lg="4" md="6" xs="12"
             v-if="$can('manage','pos') && wizard.document_operation == manageDocuments.UPLOAD  && psp=='PASARGAD'">
                <kt-form-action style=" display: inline;">
                    <kt-button
                            class="m-2"
                            size="md"
                            @click="checkDocumentsByPSP"
                            variant="success"
                            type="submit"
                            v-bind:wide="true"
                            id="check_docs_by_psp"
                    >
                        {{ $t('pos.check_documents_by_psp') }}
                    </kt-button>
                </kt-form-action>
            </kt-col>
            <kt-col v-if="$can('manage','pos') && wizard.operation =='create'"
                    lg="5" md="5" xs="7">
                <kt-form-action style=" display: inline;">
                    <kt-button
                            class="m-2"
                            size="md"
                            @click="submit('register_by_admin')"
                            variant="success"
                            type="submit"
                            v-bind:wide="true"
                            id="register_by_admin"
                    >
                        {{ $t('btn.register') }}
                    </kt-button>
                </kt-form-action>
            </kt-col>
            <kt-col v-if="!$can('manage','pos') && (wizard.operation=='create' || wizard.operation=='edit' ||
            form_data.status == posStatuses.CORRECTION || form_data.status == posStatuses.PENDING)"
                    lg="4" md="6" xs="12">
                <kt-form-action style=" display: inline;">
                    <kt-button
                            class="m-2"
                            size="md"
                            @click="submit('Pending')"
                            variant="warning"
                            type="submit"
                            v-bind:wide="true"
                            id="temporary_register"
                    >
                        {{ $t('pos.temporary_register') }}
                    </kt-button>
                </kt-form-action>
                <kt-form-action style=" display: inline;">
                    <kt-button
                            class="m-2"
                            size="md"
                            @click="submit('AgencyCheck')"
                            variant="success"
                            type="submit"
                            v-bind:wide="true"
                            id="register"
                    >
                        {{ $t('pos.send_to_agency') }}
                    </kt-button>
                </kt-form-action>
            </kt-col>
        </kt-row>
    </div>
</template>

<script>
import $ from 'jquery';
import {i18n} from '@/plugins/i18n';
import toastr from "toastr";
import {mapGetters} from "vuex";
import NovinDocuments from './novin-pos-documents';
import Pasargad from "./pasargad-pos-documents";
import {posStatuses, manageDocuments} from '@/constants/PosStatus';
import {posService} from '@/common/api.service';
import {KTApp} from '@/plugins/core/app';


export default {
    name: 'pos-documents',
    components: {
        'pasargad-documents': Pasargad,
        'novin-documents': NovinDocuments
    },
    data() {
        return {
            posStatuses,
            manageDocuments
        }
    },
    props: {
        wizard: {
            type: Object
        },
        form_data: {
            type: Object
        },
        register: {
            type: Function
        }
    },
    methods: {
        submit(action) {
            let form = $('#documents')
            let btn = null
            let hide = null
            if (action === 'edit_all_by_admin') {
                btn = $('#edit_all_by_admin')
            } else {
                if (action === 'AgencyCheck') {
                    btn = $('#register')
                    hide = 'temporary_register'
                    this.form_data.status = posStatuses.AGENCY_CHECK
                } else if (action === 'register_by_admin') {
                    btn = $('#register_by_admin')
                    this.form_data.status = posStatuses.AGENCY_CHECK
                } else {
                    btn = $('#temporary_register')
                    hide = 'register'
                    this.form_data.status = posStatuses.PENDING
                }
                if (hide) {
                    document.getElementById(hide).style.display = 'none'
                    hide = document.getElementById(hide)
                }
            }
            this.register(btn, form, hide)
        },
        step_back() {
            this.wizard.current_step = 4;
        },
        afterDispatch() {
            setTimeout(() => {
                $('.kt-selectpicker').selectpicker({
                    size: 6,
                    liveSearch: true,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_chose')
                });

            }, 500);
        },
        uploadDocs() {
            let btn = $('#upload_documents')
            let old_documents = {
                documents_id: [],
                psp: this.psp,
            };
            let new_documents = {}
            let selected_documents = {};
            for (let key in this.form_data.document_checkboxes) {
                if (this.form_data.document_checkboxes[key] == true) {
                    selected_documents[key] = key
                }
            }
            if (Object.keys(selected_documents).length === 0) return this.toastr.error(i18n.t('pos.message.nothing_selected'))

            if (selected_documents) {
                for (let key in selected_documents) {
                    if (this.form_data.documents[key].id) {
                        old_documents.documents_id.push(this.form_data.documents[key].id)
                    } else if (this.form_data.images_url[key] && typeof this.form_data.images_url[key] == "string") {
                        new_documents[key] = this.form_data.documents[key]
                    }
                }
            }
            let params = {
                ...old_documents,
                ...new_documents,
                pos_request_id: this.form_data.id,
                psp: this.psp
            }
            KTApp.progress(btn)
            posService.uploadDocuments(params).then(response => {
                return this.toastr.success(response.data.message)
            }).catch(({response}) => {
                return this.toastr.error(response.data.message)
            }).finally(() => {
                KTApp.unprogress(btn)
                this.$router.push('/pos')
            })
        },
        checkDocumentsByPSP(){
            var result = confirm(i18n.t('pos.message.check_documents_by_psp'));
            if (!result) return;
            let btn = $('#check_docs_by_psp')
            KTApp.progress(btn)
            posService.sendDocumentsToPSP(this.form_data.id).then(response => {

                return this.toastr.success(response.data.message)
            }).catch(({response}) => {
                return this.toastr.error(response.data.message)
            }).finally(() => {
                KTApp.unprogress(btn)
            })
        },
    },
    mounted() {
        this.afterDispatch()
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
        ...mapGetters('pos', [
            'constants', 'psp'
        ])
    }
}
</script>
<style>
.kt-form-label {
    text-align: right !important;
}
</style>